'use strict';
var processInclude = require('base/util');
const { ajax, event } = require('jquery');
 
processInclude(require('core/thirdParty/slick'));
 
'use strict';
 
module.exports = {
    buyNowButton: function () {
      
        $('body').on('click', 'button.buyNow-swiss', function (e) {
            e.preventDefault();
            $('body').find('.popup').show();
        });
        $('body').on('click', '.popup-close, .popup', function (e) {
           
            if (e.target !== this) return;
            $('body').find('.popup').hide();
        });
    }
};